import angular from 'angular';
import { EllipsisComponent } from './ellipsis.component';

export const EllipsisModule = angular
  .module('app.components.ellipsis', [])
  .component('updEllipsis', EllipsisComponent);
